import CaptchaToGenerateTableService from 'app/admin/captchatogenerate/service/CaptchaToGenerateTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'captchaToGenerateTable',
	text: 'Captcha to generate',
	topic: 'captchaToGenerate',
	service: CaptchaToGenerateTableService,
	icon: 'person',
	editFormState: item => `/captchatogenerate/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh'/*, 'new'*/],
	filterFields: [],
	rowAction: [/*'modify', 'delete'*/],
	columns: [
		{
			key: 'count',
			text: 'Count',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'captchaType.name',
			text: 'Captcha Type',
			textKey: 'captchaType.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function CaptchaToGenerateTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('captchaToGenerateTable', reducer('captchaToGenerateTable'))(CaptchaToGenerateTable);
